/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { product } from '../models/product';
import type { productPayload } from '../models/productPayload';
import type { vw_product } from '../models/vw_product';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postProductDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postProductAnalyzeDatatables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product/analyze/datatables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postProductInventoryDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product/inventory/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of products
     * @returns vw_product A list of product
     * @throws ApiError
     */
    public getProducts(): CancelablePromise<Array<vw_product>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products',
        });
    }

    /**
     * Get product by id
     * @returns vw_product The product data
     * @throws ApiError
     */
    public getProduct({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_product> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/product/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a product by id
     * @returns any Product deleted successfully
     * @throws ApiError
     */
    public deleteProduct({
        id,
    }: {
        /**
         * The product id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/product/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Product
     * @returns any Product created successfully
     * @throws ApiError
     */
    public postProduct({
        requestBody,
    }: {
        requestBody: productPayload,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Product
     * @returns any Product updated successfully
     * @throws ApiError
     */
    public putProduct({
        requestBody,
    }: {
        requestBody: product,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/product',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }

}
